import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'buttonstep',
  templateUrl: './buttonstep.component.html',
  styleUrls: ['./buttonstep.component.scss']
})
export class ButtonstepComponent implements OnInit {

  action: string;
  @Input() direction;
  
  constructor() {
    //this.action = direction;
  }

  directivedirection: string;

  ngOnInit() {
    
    this.getDirectiveDirection();
  }

  getDirectiveDirection(){
    if (this.direction == "next"){
      this.directivedirection = "matStepperNext";
      console.log(this.directivedirection);
    } else {
      this.directivedirection = "matStepperBack";
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/utils/buttonstep/buttonstep.component.ts